import React from 'react';
import { Check } from 'lucide-react';
import { Label } from '@/app/components/ui/Label';

interface AgeSelectionProps {
  value: boolean | undefined;
  onChange: (isOver18: boolean) => void;
  name?: string;
  hideUnder18?: boolean; // For executors who must be over 18
}

export const AgeSelection = ({ value, onChange, name = 'isOver18', hideUnder18 = false }: AgeSelectionProps) => {
  return (
    <div className="space-y-2">
      <Label className="text-base font-medium text-gray-700">Age</Label>
      <div className="flex gap-6">
        <label className="flex items-center gap-2 cursor-pointer group">
          <div className="relative flex items-center justify-center">
            <input 
              type="radio" 
              name={name}
              checked={value === true}
              onChange={() => onChange(true)}
              className="sr-only" 
            />
            <div className={`h-6 w-6 rounded border-2 flex items-center justify-center shrink-0 transition-colors ${value === true ? 'bg-primary border-primary text-white' : 'bg-white border-gray-300 group-hover:border-primary/50'}`}>
              {value === true && <Check className="h-4 w-4" />}
            </div>
          </div>
          <span className="text-base font-medium text-gray-700">Over 18</span>
        </label>
        {!hideUnder18 && (
          <label className="flex items-center gap-2 cursor-pointer group">
            <div className="relative flex items-center justify-center">
              <input 
                type="radio" 
                name={name}
                checked={value === false}
                onChange={() => onChange(false)}
                className="sr-only" 
              />
              <div className={`h-6 w-6 rounded border-2 flex items-center justify-center shrink-0 transition-colors ${value === false ? 'bg-primary border-primary text-white' : 'bg-white border-gray-300 group-hover:border-primary/50'}`}>
                {value === false && <Check className="h-4 w-4" />}
              </div>
            </div>
            <span className="text-base font-medium text-gray-700">Under 18</span>
          </label>
        )}
      </div>
    </div>
  );
};

